export default __webpack_public_path__ + "static/media/sport-objects.spritesheet@2x.fb043b3c.png";